import React from "react";
import EnterpriseDealerHero from "../components/enterpriseDealerPage/EnterpriseDealerHero";
 
import Navbar from "../components/homepage/Navbar";
import WhyEnterprise from "../components/enterpriseDealerPage/WhyEnterprise";
import EnterpriseNeedMoreInfo from "../components/enterpriseDealerPage/EnterpriseNeedMoreInfo";
import { Header, Footer } from "../shared";

const EnterpriseDealerPage = () => {
  window.scrollTo(0, 0);
  return (
    <div className="BuyCertifiedDrone_backgorund">
      <div className="bg_darkblue">
        <Header />
      </div>
      {/* <EnterpriseDealerHero /> */}
      <WhyEnterprise />
      {/* <EnterpriseNeedMoreInfo /> */}
      <Footer />
    </div>
  );
};

export default EnterpriseDealerPage;
